export default "__VITE_ASSET__D8AYRK$7__"